/**
 * Replacement of all reserved characters to underlines without duplication
 *
 * @param str - file name
 * @returns Escaped file name
 */
export const escapeFileName = (str) => str.replace(/\s|<|>|:|;|"|\/|\\|\||\?|#|\*|\(|\)|\[|\]|,/g, '_').replace(/_{2,}/g, '_');
